import React from 'react';
import { Layout } from '../components/Layout';

export function Terms() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Terms of Service</h1>
        <div className="prose prose-lg max-w-none space-y-6">
          <p className="text-gray-600 text-sm">Last Updated: December 1, 2024</p>
          
          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using UPost ("Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these Terms of Service, please do not use our Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">2. Description of Service</h2>
            <p>
              UPost provides AI-powered writing tools, copyright protection services, and publishing assistance. Our services include but are not limited to:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>AI-assisted writing and editing</li>
              <li>Document creation and management</li>
              <li>Copyright registration services</li>
              <li>Amazon KDP publishing assistance</li>
              <li>Screenplay and TV pilot conversion services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">3. User Accounts</h2>
            <p>
              To access certain features of the Service, you must register for an account. You are responsible for:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Maintaining the confidentiality of your account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized use</li>
              <li>Providing accurate and complete information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">4. Intellectual Property Rights</h2>
            <p>
              <strong>Your Content:</strong> You retain all rights to the content you create using our Service. By using our Service, you grant us a limited license to host, store, and process your content solely for the purpose of providing the Service.
            </p>
            <p className="mt-4">
              <strong>Our Service:</strong> The UPost platform, including all software, features, and functionality, is owned by us and protected by copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">5. Payment Terms</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Subscription fees are billed in advance on a monthly or annual basis</li>
              <li>One-time service fees are charged before service delivery</li>
              <li>All payments are processed securely through Stripe</li>
              <li>Refunds are handled on a case-by-case basis</li>
              <li>We reserve the right to change pricing with 30 days notice</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">6. Copyright Services Disclaimer</h2>
            <p>
              While we assist with copyright registration through the U.S. Copyright Office and WGA Registry, we are not legal advisors. Our service is administrative in nature. For legal advice regarding copyright protection, please consult with a qualified attorney.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">7. AI-Generated Content</h2>
            <p>
              Our AI writing assistance tools are designed to help you create content. However:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>You are responsible for reviewing and editing all AI-generated content</li>
              <li>We do not guarantee accuracy, originality, or suitability for any purpose</li>
              <li>You should always verify facts and ensure content meets your standards</li>
              <li>AI-generated content should be considered as a draft or starting point</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">8. Prohibited Uses</h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Use the Service for any illegal purpose</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Upload malicious code or viruses</li>
              <li>Harass, abuse, or harm other users</li>
              <li>Scrape or data mine our Service without permission</li>
              <li>Resell or redistribute our Service without authorization</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">9. Termination</h2>
            <p>
              We reserve the right to terminate or suspend your account at any time for violations of these Terms. Upon termination, you may request a copy of your content within 30 days.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">10. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, UPost shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">11. Changes to Terms</h2>
            <p>
              We may update these Terms from time to time. We will notify you of significant changes via email or through the Service. Continued use after changes constitutes acceptance of the new Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mt-8 mb-4">12. Contact Information</h2>
            <p>
              For questions about these Terms, please contact us at:<br />
              <strong>Email:</strong> lscala@upost.com<br />
              <strong>Phone:</strong> (817) 320-5334<br />
              <strong>Mail:</strong> UPost.com, Arlington, TX
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
}
